<template>
  <div class="section address-reading">
    <div :class="loading ? 'loading' : ''">
      <div v-if="loading" class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
      <div
        class="current-address"
        :class="`current-address--${page.field}`"
        v-if="
          !loading &&
          page.field === 'nativeLands' &&
          nativeLands &&
          nativeLands.length > 0
        "
      >
        <span
          class="native-land"
          v-for="land in nativeLands"
          :key="land.properties.Name"
        >
          <a :href="land.properties.description" target="_blank">
            {{ land.properties.Name }}
          </a>
        </span>
      </div>
      <div
        v-else-if="(address && currentField) || loading"
        class="current-address"
        :class="`current-address--${page.field}`"
      >
        {{ loading ? "&nbsp;" : currentField }}
      </div>
      <div v-else-if="!currentField">
        <p>
          What is my address could not determine the {{ page.label }} for your
          location.
        </p>
      </div>
      <div v-else>
        <p>
          What is my address works by using the GPS from your device and looking
          up online what the address at that location is. Your location could
          not be determined, or you did not accept the request to use your
          location, so you are seeing this message instead.
        </p>
      </div>
      <AddressShareActions
        v-if="page.field === 'formattedAddress'"
        :address="address"
      />
      <table class="address-details">
        <tr
          v-if="
            loading ||
            (address &&
              address.intersection &&
              address.intersection.displayName)
          "
        >
          <th>Intersection</th>
          <td>
            {{
              address && address.intersection
                ? address.intersection.displayName
                : " "
            }}
          </td>
        </tr>
        <tr v-if="loading || (address && address.neighborhood)">
          <th>Neighborhood</th>
          <td>{{ address ? address.neighborhood : " " }}</td>
        </tr>
        <tr v-if="loading || (address && address.addressLine)">
          <th>Street Address</th>
          <td>{{ address ? address.addressLine : " " }}</td>
        </tr>
        <tr v-if="loading || (address && address.locality)">
          <th>{{ labels.locality }}</th>
          <td>{{ address ? address.locality : " " }}</td>
        </tr>
        <tr v-if="loading || (address && address.adminDistrict2)">
          <th>{{ labels.adminDistrict2 }}</th>
          <td>{{ address ? address.adminDistrict2 : " " }}</td>
        </tr>
        <tr v-if="loading || (address && address.adminDistrict)">
          <th>{{ labels.adminDistrict }}</th>
          <td>{{ address ? address.adminDistrict : " " }}</td>
        </tr>
        <tr
          v-if="
            loading ||
            (township &&
              township.townshipName &&
              !township.townshipName.includes('CCD'))
          "
        >
          <th>Township</th>
          <td>{{ township ? township.townshipName : " " }}</td>
        </tr>
        <tr v-if="loading || (address && address.postalCode)">
          <th>{{ labels.postalCode }}</th>
          <td>{{ address ? address.postalCode : " " }}</td>
        </tr>
        <tr v-if="loading || (address && address.countryRegion)">
          <th>{{ labels.countryRegion }}</th>
          <td>{{ address ? address.countryRegion : " " }}</td>
        </tr>
        <tr v-if="loading || (nativeLands && nativeLands.length > 0)">
          <th>Indigenous territories</th>
          <td v-if="!nativeLands"></td>
          <td v-else>
            <span
              class="native-land"
              v-for="land in nativeLands"
              :key="land.properties.Name"
            >
              <a :href="land.properties.description" target="_blank">
                {{ land.properties.Name }}
              </a>
            </span>
          </td>
        </tr>
        <tr v-if="loading || (address && displayCoordinates)">
          <th>Coordinates</th>
          <td>{{ address ? displayCoordinates : " " }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { round } from "@/helpers";
import AddressShareActions from "@/components/AddressShareActions.vue";

export default {
  components: { AddressShareActions },
  props: {
    page: {
      type: Object,
      required: true
    },
    address: {
      type: Object
    },
    township: {
      type: Object
    },
    loading: {
      type: Boolean
    },
    location: {
      type: Object
    },
    nativeLands: {
      type: Array
    }
  },
  computed: {
    displayCoordinates() {
      if (!this.location) {
        return null;
      }
      return `${round(this.location.point.coordinates[0], 5)}, ${round(
        this.location.point.coordinates[1],
        5
      )}`;
    },
    currentField() {
      if (!this.address || !this.page.field) {
        return null;
      }
      const { field } = this.page;
      if (field === "coordinates") {
        return this.displayCoordinates;
      }
      if (field === "township") {
        return this.township ? this.township.townshipName : null;
      }
      if (field in this.address) {
        if (field === "intersection") {
          return this.address[field].displayName;
        }
        return this.address[field];
      }
      return null;
    },
    labels() {
      if (
        this.address &&
        this.address.countryRegion &&
        this.address.countryRegion === "United States"
      ) {
        return {
          countryRegion: "Country",
          postalCode: "ZIP Code",
          adminDistrict: "State",
          adminDistrict2: "County",
          locality: "City"
        };
      }
      return {
        countryRegion: "Country/Region",
        postalCode: "Postal Code",
        adminDistrict: "State/Provence",
        adminDistrict2: "City/Region",
        locality: "City"
      };
    }
  }
};
</script>
